import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const StyledChipsDivider = styled.div`
    ${mixins.setFontVariant("captionTitle", colorsPalettes.carbon[300])}
    display: flex;
    align-items: center;
    text-transform: uppercase;
    margin-right: 8px;
`;

export const StyledChipsOperator = styled(StyledChipsDivider)`
    margin: 0 4px;
`;

export const StyledOperatorsChipItemText = styled.div`
    ${mixins.setFontVariant("chip1TopRow", colorsPalettes.carbon[500])}
`;

export const StyledComplexChipBaseWrapper = styled(Flex)<{ isDisabled?: boolean }>`
    flex-wrap: wrap;
    width: 100%;
    border-radius: 8px;
    opacity: ${({ isDisabled }) => (isDisabled ? "0.4" : "1")};
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "unset")};
`;

export const StyledComplexChipContainer = styled(StyledComplexChipBaseWrapper)`
    flex-direction: column;
    width: 251px;
    padding: 4px 8px 8px 8px;
    background: ${colorsPalettes.bluegrey[300]};
`;

export const StyledComplexChipHeader = styled(Flex)`
    justify-content: space-between;
    margin-bottom: 4px;
    flex-basis: 32px;
`;

export const StyledComplexChipContent = styled(FlexRow)`
    flex-wrap: wrap;
    align-items: baseline;
`;

export const StyledComplexChipTitle = styled(FlexRow)`
    align-items: center;
`;

export const StyledComplexChipActions = styled(FlexRow)``;

export const StyledIconButton = styled(IconButton)`
    flex-shrink: 0;

    ${SWReactIcons} {
        svg path {
            fill: ${colorsPalettes.midnight[400]};
            fill-opacity: 1;
        }
    }

    &:hover {
        ${SWReactIcons} {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
                fill-opacity: 1;
            }
        }
    }
`;
